<template src="./template.html"></template>
<script>
import Checkout from 'components/Checkout'

export default {
  name: 'membership-perks',
  components: {
    Checkout,
  },
  data() {
    return {
      cityId: this.$route.query.cityId,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/MembershipPerksCheckout/index.vue